export default "__VITE_ASSET__CFcnXD_Q__"